import { useContext } from "react";
import { GlobalContext } from "store/globalContext";

export const useCurrentUserData = () => {
  const { userData } = useContext(GlobalContext);
  const role = userData?.role ?? "Super Admin";
  const isReadOnlyAccess =
    role !== "Admin" && role !== "Super Admin" && role !== "Marketer" && role !== "Scheduler";
  const isSuperAdmin = role === "Super Admin";
  const isScheduler = role === "Scheduler";

  return {
    userData,
    role,
    isReadOnlyAccess,
    isSuperAdmin,
    isScheduler,
    organizationId: userData?.organizationId ?? "",
  };
};
